import { ReactNode, Ref } from "react";
import utilStyles from "@claroty/xdome-design-system/styles/utilStyles";
import classNames from "classnames";
import styles from "./PagePadding.module.scss";

export type PagePaddingProps = {
    className?: string;
    children: ReactNode;

    suppressPageContentClass?: boolean;
    markScrollRoot?: boolean;
    onScroll?: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void;

    centerContent?: boolean;
    padding?: boolean;
    topPadding?: boolean;
    rightPadding?: boolean;
    leftPadding?: boolean;
    isChildPage?: boolean;
    extraTopPadding?: boolean;
    suppressBottomPadding?: boolean;
};

const PagePadding = ({
    className,
    children,

    suppressPageContentClass,
    markScrollRoot,
    onScroll,

    centerContent,
    padding,
    topPadding,
    rightPadding,
    leftPadding,
    isChildPage,
    extraTopPadding,
    suppressBottomPadding,
}: PagePaddingProps & { _ref: Ref<HTMLDivElement> }) => {
    return (
        <div
            onScroll={onScroll}
            className={classNames(
                styles.pagePadding,
                !suppressPageContentClass && utilStyles.pageContent, // remove once this component is used for all pages
                (padding || extraTopPadding) && styles.sidePadding,
                rightPadding && styles.rightPadding,
                leftPadding && styles.leftPadding,
                !suppressBottomPadding && styles.bottomPadding,
                (padding || topPadding) && styles.topPadding,
                extraTopPadding && styles.extraTopPadding,
                centerContent && styles.centerContent,
                isChildPage && styles.childPageLeftPadding,

                className,
            )}
            {...(markScrollRoot ? { "data-page-scroll-root": true } : {})}>
            {children}
        </div>
    );
};

export default ({
    ref,
    ...props
}: PagePaddingProps & {
    ref?: React.Ref<HTMLDivElement>;
}) => PagePadding({ ...props, _ref: ref });
